import WarningIcon from '@material-ui/icons/Warning';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import BlockIcon from '@material-ui/icons/Block';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

import { registerStatusDomain } from './statusPresentation';

/**
 * Athlete attendance's own entry in the Status Presentation System —
 * mirrors App\Enum\CompetitionAttendanceStatus exactly. PRESENT is
 * deliberately neutral/no-icon: the exception is what needs to draw the
 * eye, not the default every athlete already has.
 */
export const ATTENDANCE_DOMAIN = 'attendance';

registerStatusDomain(ATTENDANCE_DOMAIN, {
    PRESENT: { tone: 'neutral', icon: null, className: 'attendance-present' },
    ABSENT: { tone: 'warning', icon: WarningIcon, className: 'attendance-absent' },
    WITHDRAWN: { tone: 'caution', icon: RemoveCircleIcon, className: 'attendance-withdrawn' },
    DISQUALIFIED: { tone: 'error', icon: BlockIcon, className: 'attendance-disqualified' },
    MEDICAL_WITHDRAWAL: { tone: 'info', icon: LocalHospitalIcon, className: 'attendance-medical-withdrawal' },
});
